module.exports = __webpack_public_path__ + "static/media/loading.a8be2bc2.gif";